<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  max-width: 420px;
  margin: 0 auto;
  height: 100%;
  min-height: 100vh;
  font-size: 14px;
  background: #F6F6F6;
}

</style>
